<template>
  <main class="auth">
    <div class="auth-loader" v-show="getAuthLoading">
      <app-loader/>
    </div>
    <div class="wrapper" style="overflow: auto" :class="{loading: getAuthLoading}" :style="`max-height: ${getMaxHeight()}px; min-height: ${getMinHeight()}px;`">
      <div class="links" v-if="hide">
        <div class="left">
          <router-link :to="{name: 'reg'}" class="link" active-class="active">Регистрация</router-link>
          <router-link :to="{name: 'login'}"  class="link" active-class="active">Вход</router-link>
        </div>
        <div class="right">
          <router-link :to="{name: 'rec'}" class="link">Забыли пароль?</router-link>
        </div>
      </div>
      <transition name="auth_anim" mode="out-in">
        <router-view :key="$route.name"/>
      </transition>
    </div>
  </main>
</template>

<script>
import AppLoader from "@/components/app-loader";
import {mapGetters} from "vuex";
export default {
name: "auth",
  components: { AppLoader },
  data: () => ({
    hide: true
  }),
  methods: {
    getMaxHeight(){
      if(this.$route.name == 'login') {
        return 355
      }
      if(this.$route.name == 'reg') {
        if (this.$route.query.employee_key) {
          return 458
        } else {
          return 839
        }
      }
      if(this.$route.name == 'rec') {
          return 260
      }
    },
    getMinHeight(){
      if(this.$route.name == 'login') {
        return 307
      }
      if(this.$route.name == 'reg') {
        if (this.$route.query.employee_key) {
          return 380
        } else {
          return 680
        }
      }
      if(this.$route.name == 'rec') {
        return 230
      }
    },
  },
  computed: {
  ...mapGetters(['getAuthLoading'])
  }
}
</script>

<style lang="scss">
.auth_anim-enter-active, .auth_anim-leave-active {
  transition: opacity .2s;
}
.auth_anim-enter, .auth_anim-leave-to {
  opacity: 0;
}
.auth{
  height: 100vh;
  min-height: 780px;
  margin: 0;
  //position: relative;
  overflow: scroll;
  display: flex;
  justify-content: center;
  align-items: center;

    //&:after{
    //   position: absolute;
    //   content: '';
    //   top: 0;
    //   left: 0;
    //   margin: 0;
    //   width: 100vw;
    //   height: 100vh;
    //   background: rgba(122, 129, 143, 0.50);
    //}

    &:before{
       position: absolute;
       content: '';
      background: linear-gradient(280.3deg, #29A377 4.94%, #34DFA2 94.09%);
       background-size: cover;
       //filter: blur(7px);
       top: 0;
       left: 0;
       margin: 0;
       width: 100vw;
       height: 100vh;
       min-height: 780px;
    }
}

.auth-loader{
  z-index: 5;
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  filter: unset;
}

.wrapper {
  overflow: hidden;
  z-index: 1;
  padding: 30px;
  background: #F9F9FB;
  //position: absolute;
  //top: 50%;
  //left: 50%;
  //margin-right: -50%;
  //transform: translate(-50%, -50%);
  width: 400px;
  border-radius: 4px;
  transition: all .3s, max-height .2s, min-height .1s;

  &.loading{
    filter: blur(4px);
  }

  &_item {
    margin-bottom: 16px;

    :first-child{
      margin-top: 15px;
    }
  }

  .links{
    display: flex;
    align-items: center;
    justify-content: space-between;

    .link{
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 19px;
      color: #B6BCC8;
      text-decoration: none;
      &.active{
        color: #000000;
        &:hover{
          cursor: context-menu;
        }
      }
    }
    .left{
      width: 45%;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .right{
      width: 55%;
      text-align: right;
    }
  }

  .radio{
    margin-top: 15px;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    display: flex;
    width: max-content;
    background-color: white;
    border-radius: 4px;
    border: 1px solid #EEF0F3;

    &-item {
      cursor: pointer;
      padding: 10px 15px;
      margin: 2px;
      color: #7A818F;
    }
    &-item.active {
      color: #2D3137;
      background: #EEF0F3;
      border-radius: 4px;
    }
  }

  &_label {
    font-size: 14px;
    line-height: 16px;
    font-weight: normal;
    color: #000000;
    display: block;
    margin-bottom: 7px;
  }

  &_input {
    background: #FFFFFF;
    border: 1px solid #EEF0F3;
    box-sizing: border-box;
    border-radius: 4px;
    height: 40px;
    width: 100%;
    outline: none;
    padding: 0 15px;
    color: #7A818F;
    font-size: 12px;
    line-height: 14px;
  }

  &_button {
    background: #2CB181;
    border-radius: 4px;
    color: #FFFFFF;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    height: 50px;
    width: 100%;
    margin-top: 14px;
  }
}
</style>
